import type { MultiPolygon } from "geojson";
import { NitrogenSimulationType, Status } from "./enums";
import type { FieldRecommendation } from "./field";

export const DEFAULT_CROP_ZONE_COLOR = "#3388FF";

export interface CropZoneNitrogenPlanSummary {
    id: number;
    product: number;
    initial_rate: number;
    current_rate: number;
    simulation_type: NitrogenSimulationType;
    processing_status: string;
    minimum_rate: number;
    maximum_rate: number;
    imagery_rate: null;
    target_growth_stage_label: string;
    target_date: string;
}

export interface CropZone {
    id: number;
    name: string;
    color: string;
    status?: Status;
    acres?: number | null;
    boundary?: MultiPolygon | null;
    active_target_growth_stage?: number | null;
    recommendation?: FieldRecommendation;
    default_nitrogen_plan_simulation?: CropZoneNitrogenPlanSummary | null;
    crop?: {
        id: string | number;
        name: string;
    } | null;
    n_applied_so_far?: number;
    crop_stage?: {
        id: number;
        growth_stage: string;
    } | null;
}
